import React from "react";

import Header from "../components/header";
import Breadcrumb from "../components/Breadcrumb";
import AddDetails from "../components/addDetails";
import Footer from "../components/footer";

const CreateOrder = () => {
  const breadcrumbPaths = [
    { label: "Home", href: "/dashboard" },
    { label: "Auftrag Anlegen", href: "#" },
  ];
  return (
    <div>
      <Header />
      <div className="mx-auto xl:w-1/2 lg:w-3/4 w-11/12 p-6 pb-20 pt-28 sm:pt-22 sm:pb:12 2xl:pt-36
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10">
        <Breadcrumb paths={breadcrumbPaths} />
        <AddDetails />
      </div>
      <div className="relative w-full">
        {" "}
        <Footer />{" "}
      </div>
    </div>
  );
};

export default CreateOrder;
